import { Dialog, DialogFooter, DialogType, PrimaryButton, DefaultButton, TextField } from "@fluentui/react";
import { t } from "i18next";
import React from "react";

interface DialogRecoveredDataProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const DialogConfirmRecoveredData: React.FC<DialogRecoveredDataProps> = ({ isOpen, onConfirm, onCancel }) => {

  const [confirmText, setConfirmText] = React.useState<boolean>(false);

  return (
    <Dialog
      hidden={!isOpen}
      dialogContentProps={{
        type: DialogType.normal,
        title: t("¡Ups! Encontramos algo tuyo"),
      }}
      modalProps={{
        isBlocking: true,
      }}
      maxWidth={400}
      onDismiss={onCancel}
    >
      <div>
        {t("La distribución de las empresas solo podrá modificarse una única vez. Una vez que guardes los cambios.")}
        <br />
        <br />
        <span>{t("Digita la palabra CONFIRMAR.")}</span>
      </div>

      <TextField
        type="text"
        autoFocus
        onChange={(e, value) => setConfirmText(value === "CONFIRMAR")}
      ></TextField><br />

      <DialogFooter>
        <PrimaryButton onClick={onConfirm} text={t("Continuar")} disabled={!confirmText} />
        <DefaultButton onClick={onCancel} text={t("Cancelar")} />
      </DialogFooter>
    </Dialog>
  )
};

export default DialogConfirmRecoveredData;
